/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampCategoryCampListResponse } from '../../models/camp-category-camp-list-response';

export interface GetCampCategoryCampIndex$Params {

/**
 * CampCategory name
 */
  category: string;
}

export function getCampCategoryCampIndex(http: HttpClient, rootUrl: string, params: GetCampCategoryCampIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<CampCategoryCampListResponse>> {
  const rb = new RequestBuilder(rootUrl, getCampCategoryCampIndex.PATH, 'get');
  if (params) {
    rb.path('category', params.category, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampCategoryCampListResponse>;
    })
  );
}

getCampCategoryCampIndex.PATH = '/v1/category/{category}/camp';
